import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const {
    confirmPassword,
    newPassword,
    oldPassword,
} = constantsData.forms.profile.password;

const {
    confirmPassword: confirmPasswordFieldName,
    newPassword: newPasswordFieldName,
    oldPassword: oldPasswordFieldName,
} = formFieldNamesData;

export const profilePasswordFormData = [
    {
        description: oldPassword.description,
        label: oldPassword.label,
        name: oldPasswordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
    {
        description: newPassword.description,
        label: newPassword.label,
        name: newPasswordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
    {
        description: confirmPassword.description,
        label: confirmPassword.label,
        name: confirmPasswordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
];
